import { AppData } from '../types';

export const DATA: AppData = {
  navigation: [
    { id: 'programs', label: 'Направления' },
    { id: 'vibe', label: 'Атмосфера' },
    { id: 'reviews', label: 'Отзывы' },
    { id: 'stats-section', label: 'О нас' },
  ],
  
  programs: [
    { 
      id: 1, 
      title: "Хип-хоп", 
      desc: "Научись чувствовать бит и двигаться свободно", 
      badge: "Популярное", 
      img: "/images/programs/hip-hop.png" 
    },
    { 
      id: 2, 
      title: "Брейк-данс", 
      desc: "Научись топ-року, футворку и первым силовым элементам", 
      badge: "", 
      img: "/images/programs/break-dance.png" 
    },
    { 
      id: 3, 
      title: "Contemporary", 
      desc: "Соединени танец, актерское мастерство и пластику", 
      badge: "Новое", 
      img: "/images/programs/contemporary.png" 
    },
    { 
      id: 4, 
      title: "K-Pop", 
      desc: "Стиль, энергия и полное погружение в K-Pop культуру", 
      badge: "", 
      img: "/images/programs/k-pop.png" 
    },
    { 
      id: 5, 
      title: "Хип-хоп профи", 
      desc: "Углубленная работа над манерой и экспрессией", 
      badge: "", 
      img: "/images/programs/hip-hop pro.png" 
    },
    { 
      id: 6, 
      title: "Брейк-данс профи", 
      desc: "Сложные силовые элементы и уникальный стиль", 
      badge: "", 
      img: "/images/programs/break-dance pro.png" 
    },
    { 
      id: 7, 
      title: "Афро", 
      desc: "Раскрепощение тела и невероятная энергетика", 
      badge: "", 
      img: "/images/programs/afro.png" 
    },
    { 
      id: 8, 
      title: "Джаз-фанк", 
      desc: "Резкие акценты и эмоциональная подача", 
      badge: "", 
      img: "/images/programs/jazz funk.png" 
    },

  ],
  
  reviews: [
    { 
      id: 1, 
      name: "Аня В.", 
      text: "Я вообще не танцевала до этого, но Fun dance просто бомба! Тренер Макс — очень крутой, он умеет так зажечь, что даже я начала двигаться. Атмосфера кайфовая, все такие свои. Теперь каждый урок — это не просто танцы, а целый вайб! Рекомендую всем, кто хочет оторваться и прокачать себя!", 
      stars: 5 
    },
    { 
      id: 2, 
      name: "Олег С.", 
      text: "Зашёл на занятия после работы, и это было лучшее решение! Зал — огонь, музыка — просто улёт. Танцы помогают забыть про все заботы. Тренер реально крутит так, что даже самые зажатые начинают двигаться. Если хотите весело провести время и научиться танцевать, вам точно сюда!", 
      stars: 5 
    },
    { 
      id: 3, 
      name: "Максим К.", 
      text: "В Fun dance занимаюсь уже несколько месяцев и очень доволен! Тренер Ксения вдохновляет и помогает развиваться. Атмосфера дружелюбная, и я заметил улучшение своей техники и уверенности. Рекомендую всем, кто хочет развиваться в танцах!", 
      stars: 5 
    },
  ],
  
  gallery: [
    "/images/gallery/team.png",
  ]
};